import React, { useEffect, useState } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'reactstrap';
import dayjs from 'dayjs';
import { PaginationComponent } from '../common/PaginationComponent';
import { DefaultPerPageValue } from '../../../constants/Common';
import { useSelector } from 'react-redux';
import { getAllAgendaList } from '../../../api/casp/agenda';
import AgendaItemAccordionComponent from './AgendaItemAccordion';
import { withTranslation } from 'react-i18next';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { Padding } from '@mui/icons-material';

const AgendaAccordionComponent = ({ sendReloadAccordion, editAccordionReload, agenda, openedAgendas, ind, toggleAgendas, statusList, refresh, toggleAgendaEditModal, t }) => {
    const [pageForAgendaItem, setPageForAgendaItem] = useState(0);
    const [isAgendaSelected, setIsAgendaSelected] = useState(false);
    const [rowsPerPageForAgendaItem, setRowsPerPageForAgendaItem] = useState(DefaultPerPageValue);
    const [paginationObjectForAgendaItem, setPaginationObjectForAgendaItem] = useState(null);
    const [agendaListItem, setAgendaListItem] = useState([]);

    const { user } = useSelector((state) => ({
        user: state.Profile.user,
    }));
    useEffect(() => {
        setIsAgendaSelected(openedAgendas.includes(agenda.id.toString()))

    }, [openedAgendas])
    useEffect(() => {
            if(isAgendaSelected){
            
                getAllAgendaItem({ date: agenda.date, page: 0, perPage: 10})
            }
    }, [isAgendaSelected])
    const reloadAgendaList = async () => {
        await  getAllAgendaItem({ date:sendReloadAccordion.date, page: 0, perPage: 10})
    }
    useEffect(() => {
            if(sendReloadAccordion.id !== '' && sendReloadAccordion.date !==''){
                reloadAgendaList()
        }
    }, [sendReloadAccordion])
    /**
     * 
     * @param {{ date: '', page: 0, perPage: 10 }} params date is used to fetch agenda items for each date, 
     * page is used for paginating data
     * perPage is used for listing n number of data at per page  
     * @param  paginationData this is used as a flag when changing a page then the global page value 
     * is ignored and used page no from object argument 
     */
    const getAllAgendaItem = async (params = { date: '', page: 0, perPage: 10 }, paginationData = false) => {
        try {
        setAgendaListItem([])
        params = {
            ...params,
            companyId: user.company.id,
            ...(!paginationData && {
                page: (pageForAgendaItem + 1),
            })
        }
        params.projectSpecific = false
        const res = await getAllAgendaList(params);
        setAgendaListItem(res.data.data.data)
        setPaginationObjectForAgendaItem(res.data.data.meta);
        } catch (error) {
            console.log(error);
        }
    }

    const handleChangePageForAgendaItem = async (event, newPage) => {
        setPageForAgendaItem(newPage);
        await getAllAgendaItem({ date: agenda.date, page: newPage + 1, perPage: rowsPerPageForAgendaItem }, true)
    };

    const handleChangeRowsPerPageForAgendaItem = async ({ date, perPage }) => {
        setRowsPerPageForAgendaItem(perPage);
        setPageForAgendaItem(0);
        await getAllAgendaItem({ date, page: 1, perPage }, true)
    };

    return (
    
        <Accordion className="agenda_main_accordion" key={agenda.date + '-agenda-main'} open={openedAgendas} toggle={toggleAgendas}>
            <AccordionItem className="my-2">
                <AccordionHeader
                    className="risk-mngt-accordionHeader"
                    key={`${ind}-agenda-accordion-header`}
                    targetId={String(agenda.id)}
                >
                    <div className='date_accordion_header'>
                        <CalendarTodayOutlinedIcon /> &nbsp; &nbsp;
                        <div style={{ lineHeight: '25px'}}>{t("Date")}: {dayjs(agenda.date).format('YYYY-MM-DD')}</div>
                    </div>
                </AccordionHeader>
                <AccordionBody accordionId={String(agenda.id)} className='agenda_main_body'>
                  
                    <AgendaItemAccordionComponent
                        agendaListItem={agendaListItem}
                        ind={ind}   
                        statusList={statusList}
                        setAgendaListItem={setAgendaListItem}
                        refresh={refresh}
                        toggleAgendaEditModal={toggleAgendaEditModal}
                        receivedAgenda ={agenda}
                        editAccordionReload={editAccordionReload}
                    >
                        {agendaListItem.length > 0 &&
                                <div className="d-flex justify-content-center mt-2 agenda_internal_pagination">
                                    <PaginationComponent
                                        paginationObject={paginationObjectForAgendaItem}
                                        page={pageForAgendaItem}
                                        handleChangePage={handleChangePageForAgendaItem}
                                        rowsPerPage={rowsPerPageForAgendaItem}
                                        handleChangeRowsPerPage={(event) => handleChangeRowsPerPageForAgendaItem({ date: agenda.date, perPage: event.target.value })} />
                                </div>
                            }
                    </AgendaItemAccordionComponent>
                </AccordionBody>
            </AccordionItem>
        </Accordion>
    );
};

export default withTranslation()(AgendaAccordionComponent);
